export function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function stringAvatar(name: string, hasImage?: boolean) {
  const nameSplit = name.split(" ");
  const nameSize = nameSplit.length;
  let string = "";

  if (nameSize === 1) {
    string = nameSplit[0][0];
  } else {
    string = nameSplit[0][0] + nameSplit[nameSize - 1][0];
  }

  const result: any = {
    children: string.toLocaleUpperCase(),
  };

  if (!hasImage) {
    result.sx = {
      bgcolor: stringToColor(name),
    };
  }

  return result;
}
